import React from 'react';
import { Helmet } from 'react-helmet-async';

const Impressum = () => (
  <main
    className="impressum-page"
    style={{ padding: '3rem 1rem', background: 'var(--background-color)' }}  // was #f9f9f9
  >
    <Helmet>
      <title>Legal Disclosure</title>
      {/* 🔒 Prevent search indexing */}
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>

    <div
      style={{
        background: 'var(--secondary-color)', // was #fff
        color: 'var(--text-color)',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        maxWidth: '700px',
        margin: '0 auto',
        padding: '2.5rem',
        lineHeight: 1.6,
        fontFamily: 'Merriweather, Georgia, serif',
      }}
    >
      <h1 style={{ fontSize: '1.8rem', marginBottom: '1.5rem', textAlign: 'center', color: 'var(--highlight-color)' }}>
        Legal Disclosure
      </h1>

      <p>
        <strong>Business Name:</strong> <br />
        Karl Noah Bromarf <br />
      </p>

      <p>
        <strong>Organisation Number:</strong> <br />
        199905234275
      </p>

      <p>
        <strong>Registered Address:</strong> <br />
        Domherrevägen 4A <br />
        192 55 Sollentuna <br />
        Sweden
      </p>

      <p>
        <strong>Contact:</strong> <br />
        Email:{' '}
        <a
          href="noah@hermesreads.com"
          style={{ color: 'var(--primary-color)', textDecoration: 'none' }} // was #0056b3
        >
          noah@hermesreads.com
        </a>
        <br />
        For general or legal inquiries, please use the contact form in the website header.
      </p>
    </div>
  </main>
);

export default Impressum;
